import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { A } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import useDemandResponseContext from "../../context/useDemandResponseContext";
import { useTheme } from "../../../ThemeContext/ThemeContext";

const SmallCalendar = () => {
  const { selectedDate, setSelectedDate } =
    useDemandResponseContext();
  const { colors } = useTheme();
  const handleDateChange = (date) => {
    setSelectedDate(date.toDate());
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar
        views={["day"]}
        onChange={handleDateChange}
        sx={{
          "& .MuiPickersDay-root.Mui-selected, .MuiPickersDay-root.Mui-selected:focus, .MuiPickersDay-root.Mui-selected.Mui-focusVisible": {
  backgroundColor: colors?.primary?.main,
  color: "#fff",
},
          "& .MuiPickersDay-root.Mui-disabled": {
            color: colors?.text?.muted,
          },
          "& .MuiPickersDay-root:hover": {
            backgroundColor: colors?.hover?.primary,
            color: "#fff",
          },
          "& .MuiPickersDay-root": {
            color: colors?.text?.primary,
          },
          "& .MuiDayCalendar-weekDayLabel": {
            color: colors?.text?.secondary,
          },
          "& .MuiPickersArrowSwitcher-root .MuiIconButton-root": {
            color: colors?.primary?.main, 
          }, 
          "& .MuiPickersCalendarHeader-label": {
            color: colors?.text?.primary,
          },
          "& .MuiPickersDay-root.MuiPickersDay-today": {
            border: `1px solid ${colors?.text?.muted}`, 
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default SmallCalendar;
